import ClassroomAPI from '@skooldio/classroom-frontend-api';

import getConfig from '../Util/Config';

const getStoreApolloClient = () => {
  const storeGraphApi = getConfig().storeGraphApi;
  return ClassroomAPI.createClient({
    graphqlPath: storeGraphApi,
  });
};

export default getStoreApolloClient;
